<!--
     Copyright (c) 2021-2024 Broadcom. All Rights Reserved.
     Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
     and/or its subsidiaries.
-->
<clr-main-container>
    <clr-alerts *ngIf="appLevelBanners?.length">
        <clr-alert *ngFor="let alert of appLevelBanners"
                   [clrAlertType]="alert.type"
                   [clrAlertAppLevel]="true"
                   [clrAlertClosed]="false"
                   [clrAlertClosable]="false">
            <clr-alert-item>
                <span class="alert-text">
                    {{alert.message}}
                </span>
            </clr-alert-item>
        </clr-alert>
    </clr-alerts>
    <vmw-toast-container *ngIf="appLevelToasts?.length">
        <vmw-toast *ngFor="let alert of appLevelToasts"
                   [type]="alert.type"
                   [timeoutSeconds]="-1">
            <div class="toast-title">{{alert.title}}</div>
            <p class="toast-description">{{alert.message}}</p>
        </vmw-toast>
    </vmw-toast-container>
    <csp-header [title]="htmlTitleKey | vtranslate"
                [options]="headerOptions"
                [authToken]="accessToken"
                (switchOrg)="orgChange($event)"
                (selectedOrgChange)="selectedOrgChange($event)"
                (signOut)="oAuth2Client.revoke()"
                (showing)="drawerShowing = true"
                (hiding)="drawerShowing = false"
                [notification]="this.notificationService.getNotifications()"
                [environment]="cspEnvironment"
                (notificationClick)="this.notificationService.executePrimaryAction($event)"
                (skipToContentClick)="goToContent($event)"
                *ngIf="!appStateService.isError404"
                role="banner">
    </csp-header>
    <div class="content-container">
        <router-outlet></router-outlet>
    </div>
    <div class="dialogAnchorWrapper">
        <div dialogAnchor></div>
    </div>
</clr-main-container>
